import { Outlet } from "react-router-dom";

export default function FeedbackPage() {
  return <Outlet />;
}
